import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isUsingMeasuringToolState, distanceToPolygonInfoState } from '../../../../../../app/redux/retrievers/retrievers';
import { Polyline, Popup } from 'react-leaflet';

const DistanceToPolygonLine = () => {
    const distanceToPolygonInfo = useSelector(distanceToPolygonInfoState);
    const isUsingMeasuringTool = useSelector(isUsingMeasuringToolState);

    const [polylineKey, setPolylineKey] = useState<number>(0);

    useEffect(() => {
        /*generate new key for polygon component each time coords are updated to fix editing bug*/
        setPolylineKey(polylineKey + 1 * Math.random());
    }, [isUsingMeasuringTool]);

    return (
        distanceToPolygonInfo.polylineCoords && (
            <>
                <Polyline key={polylineKey} positions={[distanceToPolygonInfo.polylineCoords]} color="red" />
                <Popup
                    className="measure-tooltip"
                    position={distanceToPolygonInfo.polylineCoords[0]}
                    closeOnClick={false}
                    autoClose={false}
                    closeButton={false}
                >
                    <span>فاصله: </span>
                    <span style={{ fontWeight: 'bold' }}>{distanceToPolygonInfo.distance}</span>
                    <span> متر</span>
                </Popup>
            </>
        )
    );
};

export default DistanceToPolygonLine;
